import React, { useEffect, useRef, useState } from 'react';
const ASSET_SHARED_BG = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/key-features-bg-bta3dso6cwk.png';
type Tab = {
  id: string;
  title: string;
  description: string;
  squareColor: string;
  iconUrl: string;
  foregroundUrl: string;
};
const TABS: Tab[] = [{
  id: 'ai-shopping-assistant',
  title: 'AI shopping assistant',
  description: 'The Assistant knows your full catalog and answers like someone who works there.',
  squareColor: '#D6BAFA',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-1-gvj5q8353ok.png',
  foregroundUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/key-features-asset-1-jvc1w3qum5.png'
}, {
  id: 'ai-store-apps',
  title: 'AI store apps',
  description: "Quiz when they're choosing. Comparison when they're stuck. Size guide when they're worried. The right component, built for the right moment.",
  squareColor: '#FF5C21',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-2-gpof6s0pyzw.png',
  foregroundUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/key-features-asset-2-w1j7b15oat.png'
}, {
  id: 'dynamic-collections',
  title: 'Dynamic collections',
  description: "Collections that build themselves. Based on what's selling, what's trending, and what each shopper is into. No manual curation.",
  squareColor: '#82D9F2',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-3-b18l5foue6q.png',
  foregroundUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/key-features-asset-3-0i96imfwwqzj.png'
}];
const AUTOPLAY_MS = 10000;
export const AIStorefrontDelight = () => {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  const [active, setActive] = useState(0);
  const [hoveredTab, setHoveredTab] = useState<number | null>(null);
  const [inView, setInView] = useState(false);
  const timerRef = useRef<number | null>(null);
  const userPaused = useRef(false);
  const sectionRef = useRef<HTMLElement>(null);
  const isMobile = windowWidth <= 767;
  const isCompact = windowWidth <= 1024; // accordion mode on mobile + tablet
  const sidePad = isMobile ? '16px' : '24px';
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Deep-link from feature grid
  useEffect(() => {
    const handler = (e: Event) => {
      const {
        section,
        tab
      } = (e as CustomEvent).detail;
      if (section === 'delight') goTo(tab);
    };
    window.addEventListener('aisf-goto', handler);
    return () => window.removeEventListener('aisf-goto', handler);
  }, []);

  // IntersectionObserver — used for desktop autoplay trigger
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold: 0.2
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const goTo = (idx: number) => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    userPaused.current = true;
    setActive(idx);
  };

  // Autoplay — desktop only, no progress stroke on compact
  useEffect(() => {
    if (!inView || isCompact || userPaused.current) return;
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setActive(prev => (prev + 1) % TABS.length);
    }, AUTOPLAY_MS);
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [active, inView, isCompact]);
  const toggleTab = (i: number) => setActive(prev => prev === i ? -1 : i);
  const demoButton = <div style={{
    marginTop: '40px',
    textAlign: 'center'
  }}>
      <a href="/book-a-demo" style={{
      display: 'inline-block',
      backgroundColor: '#091717',
      color: '#FCFAF6',
      fontFamily: 'Instrument Sans, sans-serif',
      fontWeight: 400,
      fontSize: '16px',
      borderRadius: '999px',
      padding: '12px 24px',
      textDecoration: 'none',
      transition: 'opacity 0.2s ease'
    }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-aisf-delight-demo">
        Book a demo
      </a>
    </div>;

  // ── Compact: accordion (mobile + tablet ≤1024px) ────────────────────────
  if (isCompact) {
    return <section id="aisf-delight" ref={sectionRef} data-name="AI Storefront Delight" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: 'clamp(60px, 8vw, 120px)',
      paddingBottom: 'clamp(60px, 8vw, 120px)'
    }}>
        <div style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: sidePad,
        paddingRight: sidePad
      }}>
          <h2 style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#091717',
          margin: '0 0 32px 0',
          fontWeight: 400
        }}>
            <span style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>Delight</span>
            {' '}
            <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>for every shopper</span>
          </h2>

          {TABS.map((tab, i) => {
          const isOpen = active === i;
          return <div key={tab.id} style={{
            borderTop: '1px solid rgba(9,23,23,0.12)'
          }}>
                {/* Accordion header */}
                <button type="button" onClick={() => toggleTab(i)} style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 0',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              fontFamily: 'Instrument Sans, sans-serif',
              color: '#091717',
              transition: 'background-color 200ms ease'
            }} data-tracking-id="btn-265d05adba9123ca">
                  <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                opacity: isOpen ? 1 : 0.5,
                transition: 'opacity 200ms ease'
              }}>
                    <span aria-hidden="true" style={{
                  width: '40px',
                  height: '40px',
                  flexShrink: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: isOpen ? tab.squareColor : 'rgba(9, 23, 23, 0.05)',
                  transition: 'background-color 200ms ease'
                }}>
                      <img src={tab.iconUrl} alt="" aria-hidden="true" style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                    display: 'block'
                  }} />
                    </span>
                    <span style={{
                  fontSize: '20px',
                  fontWeight: 500,
                  letterSpacing: '-0.02em',
                  lineHeight: 1.3
                }}>
                      {tab.title}
                    </span>
                  </div>
                  <span aria-hidden="true" style={{
                fontSize: '24px',
                lineHeight: 1,
                flexShrink: 0,
                marginLeft: '16px',
                opacity: isOpen ? 1 : 0.4,
                transition: 'opacity 200ms ease'
              }}>
                    {isOpen ? '−' : '+'}
                  </span>
                </button>

                {/* Expandable content */}
                <div style={{
              maxHeight: isOpen ? '900px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.4s ease'
            }}>
                  <div style={{
                paddingBottom: '24px'
              }}>
                    <p style={{
                  fontSize: '16px',
                  lineHeight: 1.5,
                  fontWeight: 400,
                  color: '#091717',
                  fontFamily: 'Instrument Sans, sans-serif',
                  margin: 0,
                  padding: '4px 0 20px'
                }}>
                      {tab.description}
                    </p>
                    {/* Asset: foreground image on shared background */}
                    <div style={{
                  backgroundImage: `url(${ASSET_SHARED_BG})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                      <img src={tab.foregroundUrl} alt={tab.title} style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain'
                  }} />
                    </div>
                  </div>
                </div>
              </div>;
        })}
          {/* Bottom border */}
          <div style={{
          borderTop: '1px solid rgba(9,23,23,0.12)'
        }} />

          {demoButton}
        </div>
      </section>;
  }

  // ── Desktop: slider ──────────────────────────────────────────────────────
  return <>
      <style>{`
        @keyframes aisfProgress {
          from { transform: scaleX(0); }
          to   { transform: scaleX(1); }
        }
      `}</style>

      <section id="aisf-delight" ref={sectionRef} data-name="AI Storefront Delight" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: 'clamp(60px, 8vw, 120px)',
      paddingBottom: 'clamp(60px, 8vw, 120px)'
    }}>
        <div style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: sidePad,
        paddingRight: sidePad
      }}>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '44px'
        }}>
            <h2 style={{
            fontSize: 'clamp(52px, 7vw, 92px)',
            lineHeight: 1.05,
            color: '#091717',
            margin: 0,
            fontWeight: 400
          }}>
              <span style={{
              fontFamily: 'Instrument Serif, serif',
              fontStyle: 'italic',
              fontWeight: 400,
              letterSpacing: '-0.02em'
            }}>Delight</span>
              {' '}
              <span style={{
              fontFamily: 'Instrument Sans, sans-serif',
              fontWeight: 400
            }}>for every shopper</span>
            </h2>
            <a href="/book-a-demo" style={{
            display: 'inline-block',
            backgroundColor: '#091717',
            color: '#FCFAF6',
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            borderRadius: '999px',
            padding: '12px 24px',
            textDecoration: 'none',
            transition: 'opacity 0.2s ease',
            flexShrink: 0
          }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.opacity = '1'} data-tracking-id="btn-aisf-delight-demo">
              Book a demo
            </a>
          </div>

          {/* Asset container */}
          <div style={{
          position: 'relative',
          width: '100%',
          height: 'clamp(440px, 46vw, 670px)',
          overflow: 'hidden'
        }}>
            <img src={ASSET_SHARED_BG} alt="" aria-hidden="true" style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }} />
            {TABS.map((tab, i) => <img key={tab.id} src={tab.foregroundUrl} alt={tab.title} style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            maxWidth: '100%',
            maxHeight: 'calc(100% - 44px)',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom center',
            opacity: i === active ? 1 : 0,
            transition: 'opacity 600ms ease',
            pointerEvents: 'none'
          }} />)}
          </div>

          {/* Tabs */}
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: 0
        }}>
            {TABS.map((tab, i) => {
            const isActive = i === active;
            const isHovered = hoveredTab === i;
            const showColor = isActive || isHovered;
            const opacity = isActive || isHovered ? 1 : 0.5;
            return <button key={tab.id} type="button" onClick={() => goTo(i)} onMouseEnter={() => setHoveredTab(i)} onMouseLeave={() => setHoveredTab(cur => cur === i ? null : cur)} aria-pressed={isActive} style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              textAlign: 'left',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: isActive ? '#F2F0E9' : 'transparent',
              padding: '32px',
              fontFamily: 'Instrument Sans, sans-serif',
              color: '#091717',
              transition: 'background-color 200ms ease',
              overflow: 'hidden'
            }} data-tracking-id={`btn-2ad6c52718362b72_${tab.id}`}>
                  {/* Progress stroke — desktop only, mounts only when inView */}
                  {isActive && inView && <span key={`progress-${active}`} aria-hidden="true" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '2px',
                backgroundColor: tab.squareColor,
                transformOrigin: 'left center',
                animation: `aisfProgress ${AUTOPLAY_MS}ms linear forwards`
              }} />}
                  {/* Square + title */}
                  <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                opacity,
                transition: 'opacity 200ms ease',
                marginBottom: '12px'
              }}>
                    <span aria-hidden="true" style={{
                  width: '40px',
                  height: '40px',
                  flexShrink: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: showColor ? tab.squareColor : 'rgba(9, 23, 23, 0.05)',
                  transition: 'background-color 200ms ease'
                }}>
                      <img src={tab.iconUrl} alt="" aria-hidden="true" style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                    display: 'block'
                  }} />
                    </span>
                    <div style={{
                  fontSize: '20px',
                  lineHeight: 1.3,
                  fontWeight: 500,
                  letterSpacing: '-0.02em'
                }}>{tab.title}</div>
                  </div>
                  {/* Description */}
                  <div style={{
                fontSize: '16px',
                lineHeight: 1.5,
                fontWeight: 400,
                color: '#091717',
                opacity,
                transition: 'opacity 200ms ease'
              }}>
                    {tab.description}
                  </div>
                </button>;
          })}
          </div>
        </div>
      </section>
    </>;
};